import React from "react";

import { Code } from "@packages/ds";
import { useIntl } from "react-intl";
import styled from "styled-components";

interface ValidateIntegrationProps {
  validateCmd: string;
}

const ValidateIntegration = ({ validateCmd }: ValidateIntegrationProps) => {
  const intl = useIntl();
  return (
    <Cmds>
      <article>
        <label>
          {intl.formatMessage({
            id: "integration.verify",
            defaultMessage: "Verify integration"
          })}
        </label>
        <Code.Block singleLine id={validateCmd} isCopyable>
          {validateCmd}
        </Code.Block>
      </article>
    </Cmds>
  );
};

const Cmds = styled.section`
  display: block;

  article {
    display: inline-block;
    width: 400px;
    margin-right: 32px;

    label {
      display: block;
      margin-bottom: 8px;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: var(--section-slate-color, var(--slate));
    }
  }
`;

export default ValidateIntegration;
